module.exports = __webpack_public_path__ + "img/end-image_las-vegas-market.a97aab1b.jpg";